import { render } from "./Whatsapp.vue?vue&type=template&id=1949f13c&scoped=true"
import script from "./Whatsapp.vue?vue&type=script&lang=js"
export * from "./Whatsapp.vue?vue&type=script&lang=js"

import "./Whatsapp.vue?vue&type=style&index=0&id=1949f13c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1949f13c"]])

export default __exports__